import axios from 'axios'
import axiosAuthRequired from './axiosAuthRequired'

const getAuthHeaders = () => {
  let headers = {}
  let clientCredentials = window.localStorage.getItem('client_credentials')
  if (clientCredentials) {
    headers['Authorization'] = 'Bearer ' + clientCredentials
  }

  return headers
}

export const fetchWeaponTierLists = (id) => {
  return axios({
    method: 'get',
    url: '/api/v2/game-resources/csgo/maps/' + id + '/tier-lists'
  }).then((response) => {
    return response.data
  }).catch((error) => {
    return Promise.reject(error)
  })
}

export const fetchAllMaps = () => {
  return axios({
    method: 'get',
    url: '/api/v2/game-resources/csgo/static-data/maps'
  }).then((response) => {
    return response.data
  }).catch((error) => {
    return Promise.reject(error)
  })
}

export const fetchMapById = (id) => {
  return axios({
    method: 'get',
    url: '/api/v2/game-resources/csgo/static-data/maps/' + id
  }).then((response) => {
    return response.data
  }).catch((error) => {
    return Promise.reject(error)
  })
}

export const fetchMapVideos = (key) => {
  return axiosAuthRequired({
    method: 'get',
    url: '/api/v2/game-resources/csgo/maps/' + key + '/video-guides',
    headers: getAuthHeaders()
  }).then((response) => {
    return response.data
  }).catch((error) => {
    return Promise.reject(error)
  })
}

export const fetchMapStats = (key) => {
  return axios({
    method: 'get',
    url: '/api/v2/game-resources/csgo/maps/' + key + '/stats'
  }).then((response) => {
    return response.data
  }).catch((error) => {
    return Promise.reject(error)
  })
}

export const fetchAllItems = () => {
  return axios({
    method: 'get',
    url: '/api/v2/game-resources/csgo/static-data/items'
  }).then((response) => {
    return response.data
  }).catch((error) => {
    return Promise.reject(error)
  })
}

export const fetchAllWeapons = () => {
  return axios({
    method: 'get',
    url: '/api/v2/game-resources/csgo/static-data/items/weapon'
  }).then((response) => {
    return response.data
  }).catch((error) => {
    return Promise.reject(error)
  })
}

export const fetchWeaponById = (id) => {
  return axios({
    method: 'get',
    url: '/api/v2/game-resources/csgo/static-data/items/weapon/' + id
  }).then((response) => {
    return response.data
  }).catch((error) => {
    return Promise.reject(error)
  })
}

export const fetchWeaponVideos = (key) => {
  return axiosAuthRequired({
    method: 'get',
    url: '/api/v2/game-resources/csgo/weapons/' + key + '/video-guides',
    headers: getAuthHeaders()
  }).then((response) => {
    return response.data
  }).catch((error) => {
    return Promise.reject(error)
  })
}

export const fetchWeaponTips = (key) => {
  return axios({
    method: 'get',
    url: '/api/v2/game-resources/csgo/weapons/' + key + '/tips'
  }).then((response) => {
    return response.data
  }).catch((error) => {
    return Promise.reject(error)
  })
}

export const fetchWeaponRecoilVisuals = (key) => {
  return axios({
    method: 'get',
    url: '/api/v2/game-resources/csgo/weapons/' + key + '/recoil-visuals'
  }).then((response) => {
    return response.data
  }).catch((error) => {
    return Promise.reject(error)
  })
}

export const fetchMapWeaponTierList = (key) => {
  return axios({
    method: 'get',
    url: '/api/v2/game-resources/csgo/maps/' + key + '/tier-lists'
  }).then((response) => {
    return response.data
  }).catch((error) => {
    return Promise.reject(error)
  })
}

export const fetchMapWeaponBuyGuides = (key) => {
  return axios({
    method: 'get',
    url: '/api/v2/game-resources/csgo/maps/' + key + '/buy-guides'
  }).then((response) => {
    return response.data
  }).catch((error) => {
    return Promise.reject(error)
  })
}

export const fetchMapMarkers = (key) => {
  return axios({
    method: 'get',
    url: '/api/v2/game-resources/csgo/maps/' + key + '/markers',
    headers: getAuthHeaders()
  }).then((response) => {
    return response.data
  }).catch((error) => {
    return Promise.reject(error)
  })
}



// WEBPACK FOOTER //
// ./src/api/csgo.js